import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tslbcx",
  "use": "icon-tslbcx-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tslbcx\"><defs><style type=\"text/css\"></style></defs><path d=\"M88 838h848v48H88zM225.82 590.31l-3.14-47.9 294.63-19.32 18.8-295.2 47.91 3.05-21.49 337.28-336.71 22.09z\" p-id=\"2931\" /><path d=\"M410.48 838L143.83 571.35l421.79-421.79 290.17 290.18L457.53 838h67.88l398.26-398.26L565.62 81.68 75.95 571.35 342.59 838h67.89z\" p-id=\"2932\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol